module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper-page"
  }, [_c('div', {
    attrs: {
      "id": "pano"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-list",
    attrs: {
      "id": "menuItems"
    }
  }, _vm._l((_vm.menus), function(menu, index) {
    return _c('span', {
      key: index,
      staticClass: "menu-item",
      on: {
        "click": function($event) {
          return _vm.menuBtnClick(menu)
        }
      }
    }, [_vm._v(_vm._s(menu.name))])
  }), 0), _vm._v(" "), (_vm.currentLand && _vm.currentLand.areaLevel == 3) ? _c('div', {
    staticClass: "amount-msg"
  }, [_c('p', [_vm._v("剩余数量：" + _vm._s(_vm.getLeftNum))]), _vm._v(" "), _c('p', [_vm._v("总共数量：" + _vm._s(_vm.getTotalNum))])]) : _vm._e(), _vm._v(" "), (_vm.selectedLand) ? _c('div', {
    staticClass: "land-detail"
  }, [_c('p', [_vm._v("地块名称：" + _vm._s(_vm.selectedLand.areaName))]), _vm._v(" "), _c('p', [_vm._v("地块详情：" + _vm._s(_vm.selectedLand.plotSize || 0) + "m²")]), _vm._v(" "), (_vm.selectedLand.buyTime) ? [_c('p', [_vm._v("认购日期：" + _vm._s(_vm.selectedLand.buyTime || ''))]), _vm._v(" "), _c('p', [_vm._v("到期日期：" + _vm._s(_vm.selectedLand.endTime || ''))])] : [_c('p', [_vm._v("有效期年限：" + _vm._s(_vm.selectedLand.effectYear || '-') + "年")]), _vm._v(" "), (!_vm.selectedLand.userId) ? _c('span', {
    staticClass: "purchase-btn",
    on: {
      "click": _vm.toPurchaseDetail
    }
  }, [_vm._v("去认购")]) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), (_vm.currentLand && _vm.currentLand.areaLevel > 1) ? _c('div', {
    staticClass: "back-btn",
    on: {
      "click": _vm.toHigherLand
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "land-list"
  }, _vm._l((_vm.landList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "land-item",
      on: {
        "click": function($event) {
          return _vm.toLowerLand(item)
        }
      }
    }, [_c('img', {
      staticClass: "land-item-image",
      attrs: {
        "src": _vm._f("filterPrefix")(item.areaImg || _vm.placeholderImg)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "land-item-name"
    }, [_vm._v(_vm._s(item.areaName))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09714aee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MobileVR.vue
// module id = 1070
// module chunks = 1